<template>
  <div class="ee-container">
    <div class="input-section" :class="{ 'edit-mode': editingId }">
      <div class="input-row">
        <div class="input-item">
          <span class="input-title">名称</span>
          <input
            type="text"
            v-model="currentItem.name"
            class="input-field"
            placeholder="请输入"
          />
        </div>
        <div class="input-item">
          <span class="input-title">单位</span>
          <input
            type="text"
            v-model="currentItem.unit"
            class="input-field input-field-short"
            placeholder="请输入"
          />
        </div>
        <div class="input-item">
          <span class="input-title">数量</span>
          <input
            type="number"
            v-model.number="currentItem.quantity"
            class="input-field input-field-short"
            placeholder="请输入"
            min="0"
          />
        </div>
        <div class="input-item">
          <span class="input-title">单价(元)</span>
          <input
            type="number"
            v-model.number="currentItem.unitPrice"
            class="input-field input-field-short"
            placeholder="0.00"
            min="0"
            step="0.01"
          />
        </div>
        <div class="input-item">
          <span class="input-title">运费费率(%)</span>
          <input
            type="number"
            v-model.number="currentItem.freightRate"
            class="input-field input-field-short"
            placeholder="0.00"
            min="0"
            step="0.01"
          />
        </div>
        <div class="input-item">
          <span class="input-title">安装费率(%)</span>
          <input
            type="number"
            v-model.number="currentItem.installationRate"
            class="input-field input-field-short"
            placeholder="0.00"
            min="0"
            step="0.01"
          />
        </div>
        <template v-if="editingId">
          <button class="btn btn-primary" @click="handleAddOrUpdate">
            修改
          </button>
          <button class="btn btn-default" @click="cancelEdit">取消</button>
        </template>
        <template v-else>
          <button class="btn btn-primary" @click="handleAddOrUpdate">
            添加
          </button>
        </template>
      </div>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div class="th-cell th-seq">序号</div>
        <div class="th-cell th-name">名称</div>
        <div class="th-cell">单位</div>
        <div class="th-cell">数量</div>
        <div class="th-cell">单价(元)</div>
        <div class="th-cell">购置费(万元)</div>
        <div class="th-cell">运费费率</div>
        <div class="th-cell">运费(万元)</div>
        <div class="th-cell">安装费率</div>
        <div class="th-cell">安装费(万元)</div>
        <div class="th-cell">合计金额(万元)</div>
        <div class="th-cell th-op">操作</div>
      </div>
      <div class="table-body-wrapper">
        <div class="table-body">
          <div v-if="tableData.length === 0" class="empty-row">
            <div class="empty-tip">暂无数据</div>
          </div>
          <div
            v-for="(item, index) in tableData"
            :key="item.id"
            class="data-row"
          >
            <div class="td-cell th-seq">{{ index + 1 }}</div>
            <div class="td-cell td-name">{{ item.name }}</div>
            <div class="td-cell">{{ item.unit }}</div>
            <div class="td-cell">{{ item.quantity }}</div>
            <div class="td-cell">{{ formatNumber(item.unitPrice) }}</div>
            <div class="td-cell">{{ formatNumber(item.purchaseCost) }}</div>
            <div class="td-cell">
              {{ item.freightRate !== undefined && item.freightRate !== null && item.freightRate !== 0 ? item.freightRate.toFixed(2) : "" }}%
            </div>
            <div class="td-cell">{{ formatNumber(item.freightCost) }}</div>
            <div class="td-cell">
{{ item.installationRate !== undefined && item.installationRate !== null && item.installationRate !== 0 ? item.installationRate.toFixed(2) : "" }}%
            </div>
            <div class="td-cell">{{ formatNumber(item.installationCost) }}</div>
            <div class="td-cell">{{ formatNumber(item.totalCost) }}</div>
            <div class="td-cell th-op">
              <button class="btn-link" @click="editItem(item)">修改</button>
              <button class="btn-link btn-delete" @click="deleteItem(index)">
                删除
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="table-footer">
        <div class="td-cell th-seq"></div>
        <div class="td-cell td-name">合计</div>
        <div class="td-cell"></div>
        <div class="td-cell"></div>
        <div class="td-cell"></div>
        <div class="td-cell">{{ formatNumber(totalPurchaseCost) }}</div>
        <div class="td-cell"></div>
        <div class="td-cell">{{ formatNumber(totalFreightCost) }}</div>
        <div class="td-cell"></div>
        <div class="td-cell">{{ formatNumber(totalInstallationCost) }}</div>
        <div class="td-cell">{{ formatNumber(totalAmount) }}</div>
        <div class="td-cell th-op"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { totalTable, deprecia } from "@/utils/comp.js";

export default {
  name: "EquipmentEngineering",
  data() {
    return {
      currentItem: {
        name: "",
        unit: "",
        quantity: 0,
        unitPrice: 0,
        freightRate: 0,
        installationRate: 0,
      },
      tableData: [],
      installationCost: 0,
      otherCosts: 0,
      editingId: null,
      projectData: {},
    };
  },
  computed: {
    totalPurchaseCost() {
      return this.tableData.reduce(
        (sum, item) => sum + (item.purchaseCost || 0),
        0
      );
    },
    totalFreightCost() {
      return this.tableData.reduce(
        (sum, item) => sum + (item.freightCost || 0),
        0
      );
    },
    totalEquipmentCost() {
      return this.totalPurchaseCost + this.totalFreightCost;
    },
    totalInstallationCost() {
      return this.tableData.reduce(
        (sum, item) => sum + (item.installationCost || 0),
        0
      );
    },
    totalAmount() {
      return this.tableData.reduce(
        (sum, item) => sum + (item.totalCost || 0),
        0
      );
    },
    totalCost() {
      return this.totalAmount + this.installationCost + this.otherCosts;
    },
  },
  watch: {
    tableData: {
      handler() {
        this.updateVuex();
      },
      deep: true,
    },
    installationCost: {
      handler() {
        this.updateVuex();
      },
    },
    otherCosts: {
      handler() {
        this.updateVuex();
      },
    },
  },
  mounted() {
    this.loadFromVuex();
  },
  methods: {
    loadFromVuex() {
      this.projectData = this.$store.state.projectData || {};
      const investmentEstimate = this.projectData["总投资估算"] || {};
      const equipmentData = investmentEstimate["设备工程"] || {};
      this.setFormData(equipmentData);
    },
    addItem() {
      if (
        !this.currentItem.name ||
        !this.currentItem.unit ||
        this.currentItem.quantity <= 0 ||
        this.currentItem.unitPrice <= 0
      ) {
        this.$toast.warning("请填写完整的项目信息");
        return;
      }

      const purchaseCost =
        (this.currentItem.quantity * this.currentItem.unitPrice) / 10000;
      const freightCost = purchaseCost * (this.currentItem.freightRate / 100);
      const installationCost =
        purchaseCost * (this.currentItem.installationRate / 100);
      const totalCost = purchaseCost + freightCost + installationCost;

      const newItem = {
        ...this.currentItem,
        id: Date.now(),
        purchaseCost: purchaseCost,
        freightCost: freightCost,
        installationCost: installationCost,
        totalCost: totalCost,
      };

      this.tableData.push(newItem);
      this.resetForm();

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
    editItem(item) {
      this.editingId = item.id;
      this.currentItem = {
        name: item.name,
        unit: item.unit,
        quantity: item.quantity,
        unitPrice: item.unitPrice,
        freightRate: item.freightRate || 0,
        installationRate: item.installationRate || 0,
      };
    },
    handleAddOrUpdate() {
      if (this.editingId) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    updateItem() {
      if (
        !this.currentItem.name ||
        !this.currentItem.unit ||
        this.currentItem.quantity <= 0 ||
        this.currentItem.unitPrice <= 0
      ) {
        this.$toast.warning("请填写完整的项目信息");
        return;
      }

      const index = this.tableData.findIndex(
        (item) => item.id === this.editingId
      );
      if (index !== -1) {
        const purchaseCost =
          (this.currentItem.quantity * this.currentItem.unitPrice) / 10000;
        const freightCost = purchaseCost * (this.currentItem.freightRate / 100);
        const installationCost =
          purchaseCost * (this.currentItem.installationRate / 100);
        const totalCost = purchaseCost + freightCost + installationCost;

        this.tableData.splice(index, 1, {
          ...this.currentItem,
          id: this.editingId,
          purchaseCost: purchaseCost,
          freightCost: freightCost,
          installationCost: installationCost,
          totalCost: totalCost,
        });
      }

      this.resetForm();

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
    cancelEdit() {
      this.resetForm();
    },
    resetForm() {
      this.currentItem = {
        name: "",
        unit: "",
        quantity: 0,
        unitPrice: 0,
        freightRate: 0,
        installationRate: 0,
      };
      this.editingId = null;
    },
    deleteItem(index) {
      this.tableData.splice(index, 1);

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
    updateVuex() {
      const equipmentData = this.getFormData();
      // 确保数据结构完整
      if (!this.projectData.总投资估算) {
        this.projectData.总投资估算 = {};
      }
      this.projectData.总投资估算.设备工程 = equipmentData;
      this.$store.commit("SET_PROJECT_DATA", this.projectData);

      // 触发计算
      this.$nextTick(() => {
        totalTable();
        deprecia();
      });
    },
    getFormData() {
      return {
        购置费合计: this.totalPurchaseCost,
        运输费合计: this.totalFreightCost,
        安装费合计: this.totalInstallationCost,
        合计: this.totalCost,
        tableData: this.tableData,
      };
    },
    setFormData(data) {
      this.tableData = data["tableData"] || [];
      // 确保所有表格项目都有必要的字段
      this.tableData.forEach((item) => {
        if (!item.id) {
          item.id = Date.now() + Math.random();
        }
        item.purchaseCost = item.purchaseCost || 0;
        item.freightCost = item.freightCost || 0;
        item.installationCost = item.installationCost || 0;
        item.totalCost = item.totalCost || 0;
      });
    },
    formatNumber(num) {
  if (num === null || num === undefined || isNaN(num)) return "";
  if (num === 0) return "";
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
},
  },
};
</script>

<style scoped>
.ee-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-size: 14px;
  box-sizing: border-box;
}

.input-section {
  flex-shrink: 0;
  padding: 8px 15px;
  border-bottom: 1px solid #e4e7ed;
}

.input-section.edit-mode {
  border: 2px solid #409eff;
  background-color: #f0f7ff;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.input-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: nowrap;
}

.input-item {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.input-title {
  display: inline-block;
  margin-right: 5px;
  color: #303133;
  font-size: 14px;
  white-space: nowrap;
}

.input-field {
  width: 100px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  box-sizing: border-box;
}

.input-field:focus {
  border-color: #409eff;
  outline: none;
}

.input-field-short {
  width: 80px;
}

.btn {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  height: 28px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.btn-primary {
  background: #409eff;
  color: white;
  border: none;
}

.btn-primary:hover {
  background: #66b1ff;
}

.btn-default {
  background: white;
  color: #606266;
  border: 1px solid #dcdfe6;
  margin-left: 8px;
}

.btn-default:hover {
  color: #409eff;
  border-color: #409eff;
}

.table-container {
  position: relative;
  width: 99.5%;
  flex: 1;
  margin: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e7ed;
}

.table-header {
  display: flex;
  flex-shrink: 0;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.table-body-wrapper {
  flex: 1;
  overflow: auto;
}

.table-body {
  display: flex;
  flex-direction: column;
}

.table-footer {
  display: flex;
  flex-shrink: 0;
  background: #f0f2f5;
  border-top: 1px solid #e4e7ed;
}

.th-cell {
  padding: 8px 5px;
  border-right: 1px solid #e4e7ed;
  text-align: center;
  font-weight: 600;
  color: #303133;
  font-size: 12px;
  flex: 1;
}

.th-cell:last-child {
  border-right: none;
}

.th-seq {
  flex: none;
  width: 50px;
}

.th-name {
  text-align: left;
}

.th-op {
  flex: none;
  width: 80px;
}

.td-name {
  text-align: left;
}

.table-body .data-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;
}

.empty-row {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}

.empty-tip {
  color: #909399;
  font-size: 14px;
}

.td-cell {
  padding: 8px 5px;
  border-right: 1px solid #ebeef5;
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.td-cell:last-child {
  border-right: none;
}

.td-cell.th-seq {
  flex: none;
  width: 50px;
  text-align: center;
}

.td-cell.th-op {
  flex: none;
  width: 80px;
}

.table-body .data-row:hover {
  background: #f5f7fa;
}

.btn-link {
  background: none;
  border: none;
  color: #409eff;
  cursor: pointer;
  font-size: 12px;
  padding: 0 5px;
}

.btn-link:hover {
  text-decoration: underline;
}

.btn-delete {
  color: #f56c6c;
}

.btn-delete:hover {
  text-decoration: underline;
}

.table-footer {
  display: flex;
  flex-shrink: 0;
  background: #f0f2f5;
  border-top: 1px solid #e4e7ed;
}

@media (max-width: 1200px) {
  .input-row {
    flex-wrap: wrap;
    gap: 12px;
  }

  .input-field {
    width: 90px;
  }

  .input-field-short {
    width: 70px;
  }
}
</style>
